module.exports = __webpack_public_path__ + "img/sortable-icon.6d6c270a.svg";